import { motion } from "framer-motion";
import { Building2, HardHat, Wrench, Ruler } from "lucide-react";
import { useNavigate } from "react-router-dom";

const topServices = [
  {
    title: "Architecture",
    icon: Building2,
    desc: "Smart, sustainable buildings that shape modern skylines.",
    image: "./images/services/architecture.jpg",
  },
  {
    title: "Structural Engineering",
    icon: HardHat,
    desc: "Reliable, resilient structural systems engineered to last.",
    image: "./images/services/structural.jpg",
  },
  {
    title: "Civil Engineering",
    icon: Wrench,
    desc: "Enabling infrastructure that connects communities.",
    image: "./images/services/civil.jpg",
  },
  {
    title: "Quantity Surveying",
    icon: Ruler,
    desc: "Cost planning and budget control from start to finish.",
    image: "./images/services/quantity.jpg",
  },
];

export default function Services() {
  const navigate = useNavigate();

  // Define a click handler that navigates when called
  const handleClick = () => {
    navigate("/servicesdetail");
  };

  return (
    <section id="services" className="mx-auto max-w-7xl px-6 py-24">
      <motion.h2
        className="mb-16 text-center font-heading text-5xl font-bold text-accent"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >
        Our Expertise
      </motion.h2>

      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
        {topServices.map(({ title, icon: Icon, desc, image }, index) => (
          <motion.div
            key={title}
            className="group relative h-[420px] overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.15, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <img
              src={image}
              alt={`${title} background`}
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent z-10" />

            <div className="absolute bottom-0 z-20 w-full p-6 text-center">
              <div className="mb-4 flex items-center justify-center">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/10 backdrop-blur-md transition group-hover:scale-110">
                  <Icon className="h-6 w-6 text-accent" />
                </div>
              </div>
              <h3 className="text-lg font-semibold text-white">{title}</h3>
              <p className="mt-2 text-sm text-gray-300">{desc}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        className="mt-20 text-center"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 0.5 }}
        viewport={{ once: true }}
      >
        <button
          onClick={handleClick}
          className="inline-block rounded-full bg-accent px-10 py-4 text-primary font-semibold shadow-lg hover:shadow-xl transition hover:scale-105"
        >
          View All Services
        </button>
      </motion.div>
    </section>
  );
}
